// React imports.
import React from "react";


// App imports.
import Assessment5VendorsReportedTableRow from "./Assessment5VendorsReportedTableRow";

const Assessment5VendorsReportedTable = ({ state, step, holder, fieldChangeHandler }) => (
    <div>
        
        <br />
        <div className="vendorsReportedGrid">
            <div className="header">Main Heating Fuel</div>
            {step.showTotalVendors === true &&
                <div className="header">Total # of Vendors Serving LIHEAP Clients</div>
            }
            {step.showVendorsReceived === true &&
                <div className="header"># of Vendors from Whom Data was Received</div>
            }
            {step.showStatus === true &&
                <div className="header">Status</div>
            }
            {(step.showAllFuels === true
                || step.currentFuelName === holder.Electric.name)
                &&
                <Assessment5VendorsReportedTableRow rowClass={state.getGridRowClass(step.showAllFuels, holder.Electric.name )}  fieldChangeHandler={fieldChangeHandler} step={step}  state={state} fuel={holder.Electric} />
            }
            {(step.showAllFuels === true
                || step.currentFuelName === holder.NaturalGas.name)
                &&
                <Assessment5VendorsReportedTableRow rowClass={state.getGridRowClass(step.showAllFuels, holder.NaturalGas.name )}  fieldChangeHandler={fieldChangeHandler}step={step}  state={state} fuel={holder.NaturalGas} />
            }
            {(step.showAllFuels === true
                || step.currentFuelName === holder.FuelOil.name)
                &&
                <Assessment5VendorsReportedTableRow rowClass={state.getGridRowClass(step.showAllFuels, holder.FuelOil.name )}  fieldChangeHandler={fieldChangeHandler}step={step}  state={state} fuel={holder.FuelOil} />
            }
            {(step.showAllFuels === true
                || step.currentFuelName === holder.Propane.name)
                &&
                <Assessment5VendorsReportedTableRow rowClass={state.getGridRowClass(step.showAllFuels, holder.Propane.name )}  fieldChangeHandler={fieldChangeHandler}step={step}  state={state} fuel={holder.Propane} />
            }
            

        </div>
    </div>
);

export default Assessment5VendorsReportedTable;
